import { COPY_GENERIC } from '@sonar-software/sonar-ts-constants';
import { DetailSection } from './DetailSection';
import { getSonarObjectTypeLabel } from '@sonar-software/sonar-ts-lib';
import { SonarObjectType } from '@sonar-software/sonar-ts-types';
import { useSonarObjectReference } from '@hooks';
import React, { PropsWithChildren } from 'react';

export interface InformationSectionProps {
	headerAction?: React.ReactNode;
	sonarObjectId: number;
}

function getTitle(type: SonarObjectType | undefined): string {
	const typeLabel = type ? getSonarObjectTypeLabel(type) : undefined;

	return typeLabel ? `${typeLabel} ${COPY_GENERIC.INFORMATION}` : COPY_GENERIC.INFORMATION;
}

export const InformationSection: React.FC<PropsWithChildren<InformationSectionProps>> = ({
	children,
	headerAction,
	sonarObjectId
}) => {
	const { sonarObjectType } = useSonarObjectReference(sonarObjectId);

	return (
		<DetailSection
			headerAction={ headerAction }
			title={ getTitle(sonarObjectType) }>
			{ children }
		</DetailSection>
	);
};
